import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { archLevel } from 'src/data/config';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';
export const monitoringVisitLogApi = createApi({
  baseQuery,
  reducerPath: 'monitoringVisitLogApi',
  endpoints: builder => ({
    getAllMonitoringVisit: builder.mutation<any, any>({
      query: ({
        study_id,
        country,
        site_id,
        application_section,
        application = archLevel === 'site' ? process.env.REACT_APP_TSDA_SLUG : process.env.REACT_APP_NAME,
        from = -1,
        size = -1,
        data
      }) => {
        return {
          url: `${formatString(endPoints.MonitoringVisitLog.getAll)}?${
            study_id !== null ? `study_id=${study_id}` : ''
          }${country !== null ? `&country=${country}` : ''}${
            site_id !== null ? `&site_id=${site_id}` : ''
          }&application=${application}&application_section=${application_section}&application_module_section=STUDY LOGS${
            from > -1 ? `&from=${from}` : ''
          }${size > -1 ? `&size=${size}` : ''}`,
          method: 'POST',
          body: data
        };
      }
    }),
    imvCheckIn: builder.mutation<any, any>({
      query: ({
        visit_id,
        site_id,
        study_id,
        country,
        application,
        check_in_date,
        application_section,
        application_module_section
      }) => ({
        url: `${formatString(
          endPoints.MonitoringVisitLog.imvCheckIn,
          { key: urlKeys.monitoring_visit_id, value: visit_id },
          { key: urlKeys.check_in_date, value: check_in_date }
        )}?${study_id !== null ? `study_id=${study_id}` : ''}&${country !== null ? `country=${country}` : ''}&${
          site_id !== null ? `site_id=${site_id}` : ''
        }&application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'PUT',
        body: {}
      }),
      extraOptions: { maxRetries: 3 }
    }),
    imvCheckOut: builder.mutation<any, any>({
      query: ({
        visit_id,
        site_id,
        study_id,
        country,
        application,
        check_out_date,
        application_section,
        application_module_section
      }) => ({
        url: `${formatString(
          endPoints.MonitoringVisitLog.imvCheckOut,
          { key: urlKeys.monitoring_visit_id, value: visit_id },
          { key: urlKeys.check_out_date, value: check_out_date }
        )}?${study_id !== null ? `study_id=${study_id}` : ''}&${country !== null ? `country=${country}` : ''}&${
          site_id !== null ? `site_id=${site_id}` : ''
        }&application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'PUT',
        body: {}
      }),
      extraOptions: { maxRetries: 3 }
    }),
    sqCheckIn: builder.mutation<any, any>({
      query: ({
        visit_id,
        site_id,
        study_id,
        country,
        application,
        check_in_date,
        application_section,
        application_module_section
      }) => ({
        url: `${formatString(
          endPoints.MonitoringVisitLog.sqCheckIn,
          { key: urlKeys.monitoring_visit_id, value: visit_id },
          { key: urlKeys.check_in_date, value: check_in_date }
        )}?${study_id !== null ? `study_id=${study_id}` : ''}&${country !== null ? `country=${country}` : ''}&${
          site_id !== null ? `site_id=${site_id}` : ''
        }&application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'PUT',
        body: {}
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateVisitPurpose: builder.mutation<any, any>({
      query: ({ visit_id, site_id, study_id, country, data, application = 'CTMS', application_section }) => ({
        url: `${formatString(endPoints.MonitoringVisitLog.updateVisitPurpose, {
          key: urlKeys.monitoring_visit_id,
          value: visit_id
        })}?${study_id !== null ? `study_id=${study_id}` : ''}&${country !== null ? `country=${country}` : ''}&${
          site_id !== null ? `site_id=${site_id}` : ''
        }&application=${application}&application_section=${application_section}&application_module_section=SUBJECT TRACKING`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getMonitoringVisitAuditFilterData: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        application,
        isOnlyUpdate,
        startFrom,
        maxSize,
        sortbyColumn,
        sortOrder,
        data,
        application_section
      }) => ({
        url: `${formatString(
          endPoints.MonitoringVisitLog.MonitoringVisitAudit
        )}?study_id=${study_id}&country=${country}&site_id=${site_id}&application=${application}&only_update=${isOnlyUpdate}&from=${startFrom}&size=${maxSize}&sort_by=${sortbyColumn}&sort_order=${sortOrder}&application_section=${application_section}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    siCheckIn: builder.mutation<any, any>({
      query: ({
        visit_id,
        site_id,
        study_id,
        country,
        application,
        check_in_date,
        application_section,
        application_module_section
      }) => ({
        url: `${formatString(
          endPoints.MonitoringVisitLog.siCheckIn,
          { key: urlKeys.monitoring_visit_id, value: visit_id },
          { key: urlKeys.check_in_date, value: check_in_date }
        )}?${study_id !== null ? `study_id=${study_id}` : ''}&${country !== null ? `country=${country}` : ''}&${
          site_id !== null ? `site_id=${site_id}` : ''
        }&application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'PUT',
        body: {}
      }),
      extraOptions: { maxRetries: 3 }
    }),
    investigatorSign: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, application_section }) => ({
        url: `${formatString(endPoints.MonitoringVisitLog.investigatorSign)}?${
          study_id !== null ? `study_id=${study_id}` : ''
        }&${country !== null ? `country=${country}` : ''}&${
          site_id !== null ? `site_id=${site_id}` : ''
        }&application=${application}&application_section=${application_section}&application_module_section=SUBJECT TRACKING`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    representativeSign: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application = 'CTMS', application_section }) => ({
        url: `${formatString(endPoints.MonitoringVisitLog.representativeSign)}?${
          study_id !== null ? `study_id=${study_id}` : ''
        }&${country !== null ? `country=${country}` : ''}&${
          site_id !== null ? `site_id=${site_id}` : ''
        }&application=${application}&application_section=${application_section}&application_module_section=SUBJECT TRACKING`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateActivity: builder.query<any, any>({
      query: ({ id, site_id, study_id, country, data, application = 'CTMS', application_section }) => ({
        url: `${formatString(endPoints.MonitoringVisitLog.updateActivity, {
          key: urlKeys.monitoring_visit_id,
          value: id
        })}?${study_id !== null ? `study_id=${study_id}` : ''}&${country !== null ? `country=${country}` : ''}&${
          site_id !== null ? `site_id=${site_id}` : ''
        }&application=${application}&application_section=${application_section}&application_module_section=SUBJECT TRACKING`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    mvPublishToIsf: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data, application_section }) => ({
        url: `${formatString(
          endPoints.MonitoringVisitLog.mvPublishToIsf,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?study_id=${study_id}&country=${country}&site_id=${site_id}&application=${application}&application_section=${application_section}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    mvPublishToEtmf: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data, application_section }) => ({
        url: `${formatString(
          endPoints.MonitoringVisitLog.mvPublishToEtmf,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?study_id=${study_id}&country=${country}&site_id=${site_id}&application=${application}&application_section=${application_section}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});
export const {
  useImvCheckInMutation,
  useImvCheckOutMutation,
  useSqCheckInMutation,
  useGetAllMonitoringVisitMutation,
  useUpdateVisitPurposeMutation,
  useGetMonitoringVisitAuditFilterDataMutation,
  useSiCheckInMutation,
  useInvestigatorSignMutation,
  useRepresentativeSignMutation,
  useLazyUpdateActivityQuery,
  useMvPublishToIsfMutation,
  useMvPublishToEtmfMutation
} = monitoringVisitLogApi;
